function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { useBuildStyleWithTheme } from "../../ThemeProvider/useBuildStyleWithTheme";
var buildStyle = function() {
    return {
        wrapper: {
            base: {
                margin: '24px auto 0',
                position: 'relative',
                height: 16,
                width: 'auto',
                '&:focus': {
                    outline: 0
                }
            },
            visuallyHidden: {
                clip: 'rect(0 0 0 0)',
                clipPath: 'inset(50%)',
                height: 1,
                overflow: 'hidden',
                position: 'absolute',
                whiteSpace: 'nowrap',
                width: 1
            }
        }
    };
};
var useStyle = function(param) {
    var isRtl = param.isRtl, dotsMargin = param.dotsMargin, visibleDots = param.visibleDots;
    var builtStyle = useBuildStyleWithTheme(buildStyle, {
        isRtl: isRtl
    });
    if (!builtStyle) {
        return {
            wrapper: {}
        };
    }
    var margin = {};
    var wrapper = builtStyle.wrapper;
    if (typeof dotsMargin === 'number') {
        margin = {
            marginTop: dotsMargin,
            marginRight: dotsMargin,
            marginBottom: dotsMargin,
            marginLeft: dotsMargin
        };
    }
    if (typeof dotsMargin === 'object' && dotsMargin !== null) {
        margin = _objectSpread({}, typeof dotsMargin.top === 'number' ? {
            marginTop: dotsMargin.top
        } : {}, typeof dotsMargin.end === 'number' ? {
            marginRight: dotsMargin.end
        } : {}, typeof dotsMargin.bottom === 'number' ? {
            marginBottom: dotsMargin.bottom
        } : {}, typeof dotsMargin.start === 'number' ? {
            marginLeft: dotsMargin.start
        } : {});
    }
    return {
        wrapper: _objectSpread({}, wrapper.base, visibleDots <= 1 && wrapper.visuallyHidden, margin)
    };
};
export default useStyle;
